<template>
  <div>
<nav class="navbar navbar-expand-md navbar-light bg-light Upper">
            <a class="navbar-brand col">
              <img src="https://upload.wikimedia.org/wikipedia/commons/d/d3/Soccerball.svg" width="20" height="20" class="d-inline-block">
              {{ $t('LanguageEn.txtNavbar') }} 
            </a>
             <span style="float: right;">
              <b-button v-b-modal.modal-search style="background: none; border: none;"><img src="@/assets/search.png" style="width: 16px;" alt=""></b-button>
                <b-modal ref='mysearch-modal1' id="modal-search" title="search" hide-header hide-footer>
                  <div class="row" style="margin-bottom: 15px;margin-left: 5px; margin-right: 5px;">
                  <b-form-input class="col" v-model="message" placeholder="Search" @keyup.enter="searchT(message)"></b-form-input>
                  <b-button variant="none"  @click="searchT(message)" style="margin-left: 2px;" class="col-1">
                    <img src="@/assets/searchBlack.png" style="width: 28px; margin-top: -3px;" alt="">
                  </b-button>
                  </div>
                  <b-tabs v-if="appear" content-class="mt-2" justified style="background: white;"  active-nav-item-class="text-white bg-success" >
                <b-tab active>
                <template v-slot:title>
                    <p style="margin: 0px; color: #333333; font-size: 12px;">teams</p>
                </template>
               <ul v-for="searchr in search.results" :key="searchr.id" style="list-style-type: none;">
                  <li v-if="searchr.type == 'team'">
                    <div v-if="cookiesObject.token" @click="hideModal1()">
                    <router-link class="kek" style="color:black;" id="router-link" :to="{ name: 'teamPagePar', params: { id: searchr.id} }"> 
                      <span> {{searchr.name}}  </span>
                    </router-link>
                    </div>
                    <span class="kek" v-else data-toggle="modal" @click="hideModal1()" data-target="#exampleModal" style="cursor: pointer;" > {{searchr.name}} </span>
                  </li>
               </ul>
                </b-tab>
                <b-tab >
                <template v-slot:title >
                    <p style="margin: 0px; color: #333333; font-size: 12px;">tournaments</p>
                </template>
                  <ul v-for="searchr in search.results" :key="searchr.id" style="list-style-type: none;">
                  <li v-if="searchr.type == 'tournament'">
                    <div v-if="cookiesObject.token" @click="hideModal1()">
                     <router-link class="kek" style="color:black;" id="router-link" :to="{ name: 'LeaguePageNav', params: { leagueId: searchr.id} }"> 
                      <span > {{searchr.name}} </span>
                    </router-link>
                    </div>
                    <span class="kek" v-else data-toggle="modal" data-target="#exampleModal" style="cursor: pointer;"> {{searchr.name}} </span>
                    </li>
               </ul>
                </b-tab>
                  </b-tabs>
                </b-modal>
            </span>
          </nav>
          </div>
</template>

<script>
import { mapActions } from "vuex";
import {mapGetters} from 'vuex';

export default {


  name: 'Navbar',
     data(){
      return{
          value: '',
          dateIden: '',
          cookiesObject: '',
          search: [],
          message: '',
          appear: false,
      }
  },
  mounted(){
     var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;
  },
computed: {
   ...mapGetters(['dateNtime', 'httpReq']),
  },  
  methods: {
    ...mapActions(['setdateNtime']),
    hideModal1() {
        this.$refs['mysearch-modal1'].hide()
      },
    setLIDs(){
            this.setdateNtime(this.dateIden);
        },

       async searchT(value){
        const res = await fetch(this.httpReq + '/search?portalId=' + this.cookiesObject.portalId +'&query=' + value);
        const data = await res.json();
        const search = data;
        this.search = search;
        this.appear = true;
        },
  },
  components: {
  },
  props: {
  }
}
</script>

<style scoped>
.Upper{
    background-image: linear-gradient(#39b44a , #1b5f20);
    border-radius: 5px;
    border-bottom-left-radius: 0px ;
    border-bottom-right-radius: 0px ;
}

.navbar-brand{
    color: white !important;
    font-size: 16px !important;
}

.kek:hover{
  color: green !important;
  text-decoration: none;
}
</style>
